import Navbar from '../components/NavbarDashboard';
import NavbarMobile from '../components/NavbarDashboardMobile';
import styles from '../styles/Dashboard.module.css';
import { UserContext } from '../lib/context';
import createNewConsultRenew from '../lib/helper/createNewConsultRenew';
import { useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { firestore } from '../lib/firebase';

export default function Dashboard() {
  return (
    <>
      <Navbar />
      <Body />
    </>
  );
}

function Body() {
  const router = useRouter();

  const { user, userData, userConsults } = useContext(UserContext);
  // State Loaded
  const [userLoaded, setUserLoaded] = useState(false);
  const [userConsultLoaded, setUserConsultLoaded] = useState(false);
  const [stateLoaded, setStateLoaded] = useState(false);

  useEffect(() => {
    if (user) {
      setUserLoaded(true);
    }
  }, [user]);

  useEffect(() => {
    if (userConsults) {
      setUserConsultLoaded(true);
      userConsults.forEach((con) => console.log(con.id));
    }
    console.log(`Trigger ${userConsults}`);
  }, [userConsults]);

  useEffect(() => {
    if ((userLoaded, userData, userConsultLoaded)) {
      setStateLoaded(true);
    }
  }, [userLoaded, userData, userConsultLoaded]);

  // useEffect(() => {
  //   if (userLoaded && userConsultLoaded) {
  //     setStateLoaded(true);
  //   }
  // }, [userConsultLoaded]);

  const start = () => {
    router.push('/birth-control');
  };

  return (
    <div className={`${styles['dashboard-container']} red`}>
      <div className={`${styles['dashboard-container-max']} red`}>
        <div className={`${styles['div-flex']} red`}>
          {/* <div className={`${styles['div-2-3']} red`}>
            <div className={`${styles['dashboard-item-title']} red`}>
              Chat with Medical Team
            </div>
            <div className={`${styles['consultations-item-container']} red`}>
              Your consultations is currently under review by our medical team.
              You will receive updates from our medical team here.
            </div>
          </div> */}
          <div className={`${styles['div-100w1']} red`}>
            <div className={`${styles['dashboard-item-title']} red`}>
              My Consultations
            </div>

            {/* If stated not yet loaded */}
            {!stateLoaded && (
              <div className={`${styles['consultations-item-container']} red`}>
                <div className={`${styles['consultations-info-text']} red`}>
                  <Skeleton height={54} />
                </div>
              </div>
            )}

            {/* If state is loaded and at least one userconsult */}
            {stateLoaded && userConsults && (
              <>
                {userConsults.map((consult, i) => (
                  <Consult
                    key={i}
                    consult={consult}
                    userData={userData}
                    router={router}
                    user={user}
                  />
                ))}
              </>
            )}

            {/* If no consults */}
            {stateLoaded && !userConsults && (
              <div className={`${styles['consultations-item-container']} red`}>
                <div className={`${styles['consultations-info-text']} red`}>
                  You haven&apos;t started your consultation yet.
                </div>
                <div
                  className={`${styles['consultations-btn-text']} red`}
                  onClick={start}
                >
                  Start a new consultation
                </div>
              </div>
            )}
            <NavbarMobile />
          </div>
        </div>
      </div>
    </div>
  );
}

function Consult({ consult, router, userData, user }) {
  const [date, setDate] = useState(null);

  const complete = () => {
    if (consult.data.treatment == 'Birth Control') {
      router.push(`/birth-control/consultation/${consult.id}`);
    }
    if (consult.data.treatment == 'Acne') {
      router.push(`/acne/consultation/${consult.id}`);
    }
  };

  const cancel = async () => {
    try {
      await firestore.collection('consultations').doc(consult.id).delete();
    } catch (e) {
      console.log(e);
    }
  };

  const goToCheckout = async () => {
    try {
      if (userData?.urlID) {
        router.push(`/checkout/consult/${consult.id}`);
      } else {
        router.push(`/id/${consult.id}`);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const renew = async () => {
    try {
      await createNewConsultRenew(user, router, consult.id);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    let date1 = new Date(consult.data.updatedAt.toMillis());
    date1 = date1.toDateString();
    let split = date1.split(' ');

    let day;
    if (split[2][0] == '0') {
      day = split[2][1];
    } else {
      day = split[2];
    }
    let newDate = `${split[1]} ${day}, ${split[3]}`;
    setDate(newDate);
  }, []);

  return (
    <>
      {/* If status in progress */}
      {consult.data.status == 'in progress' && (
        <div className={`${styles['consultations-item-container']} red`}>
          <div className={`${styles['consultations-type']} red`}>
            {`${consult.data.treatment} ${
              consult.data.type == 'renewal' ? `Renewal` : `Consultation`
            }`}
          </div>
          <div className={`${styles['consultations-date']} red`}>
            {`Last updated on ${date}`}
          </div>
          <span className={`${styles['consultations-badge']} red`}>
            In progress
          </span>

          <div className={`${styles['consultations-links']} red`}>
            <div
              className={`${styles['consultations-btn-text-1']} red`}
              onClick={complete}
            >
              Complete visit
            </div>
            <div
              className={`${styles['consultations-btn-text-1']} red`}
              onClick={cancel}
            >
              Cancel visit
            </div>
          </div>
        </div>
      )}

      {/* If status submitted and paid property is false.. */}
      {consult.data.status == 'submitted' && consult.data?.paid == false && (
        <div className={`${styles['consultations-item-container']} red`}>
          <div className={`${styles['consultations-type']} red`}>
            {`${consult.data.treatment} ${
              consult.data.type == 'renewal' ? `Renewal` : `Consultation`
            }`}
          </div>
          <div className={`${styles['consultations-date']} red`}>
            {`Completed on ${date}`}
          </div>
          <span className={`${styles['consultations-badge']} red`}>
            Completed - Requires Payment
          </span>
          <div className={`${styles['consultations-links']} red`}>
            <div
              className={`${styles['consultations-btn-text-1']} red`}
              onClick={goToCheckout}
            >
              Go to checkout
            </div>
          </div>
          {/* {(process.env.NODE_ENV == 'development' ||
            userData.email == 'nana+nana111@nana.com') && (
            <div className={`${styles['consultations-links']} red`}>
              <div
                className={`${styles['consultations-btn-text-1']} red`}
                onClick={renew}
              >
                Renew Prescription
              </div>
            </div>
          )} */}
        </div>
      )}

      {/* If status is paid or reviewed or in review */}
      {(consult.data.status == 'paid' ||
        consult.data.status == 'reviewed' ||
        consult.data.status == 'in review') && (
        <div className={`${styles['consultations-item-container']} red`}>
          <div className={`${styles['consultations-type']} red`}>
            {`${consult.data.treatment} ${
              consult.data.type == 'renewal' ? `Renewal` : `Consultation`
            }`}
          </div>
          <div className={`${styles['consultations-date']} red`}>
            {`Completed on ${date}`}
          </div>
          <span className={`${styles['consultations-badge']} red`}>
            In review
          </span>
        </div>
      )}
      {/* If status approved */}
      {consult.data.status == 'approved' && (
        <div className={`${styles['consultations-item-container']} red`}>
          <div className={`${styles['consultations-type']} red`}>
            {`${consult.data.treatment} ${
              consult.data.type == 'renewal' ? `Renewal` : `Consultation`
            }`}
          </div>
          <div className={`${styles['consultations-date']} red`}>
            {`Completed on ${date}`}
          </div>
          <span className={`${styles['consultations-badge']} red`}>
            Approved
          </span>

          <div className={`${styles['consultations-links']} red`}>
            <div
              className={`${styles['consultations-btn-text-1']} red`}
              onClick={() => router.push('/prescriptions')}
            >
              Go to prescription
            </div>
          </div>
        </div>
      )}
      {/* If status declined */}
      {consult.data.status == 'declined' && (
        <div className={`${styles['consultations-item-container']} red`}>
          <div className={`${styles['consultations-type']} red`}>
            {`${consult.data.treatment} ${
              consult.data.type == 'renewal' ? `Renewal` : `Consultation`
            }`}
          </div>
          <div className={`${styles['consultations-date']} red`}>
            {`Completed on ${date}`}
          </div>
          <span className={`${styles['consultations-badge']} red`}>
            Declined
          </span>
          <div className={`${styles['consultations-date']} red`}>
            {/* {userConsult.data.doctorNotes} */}
          </div>
        </div>
      )}
    </>
  );
}
